import script from "./AlertaToast.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertaToast.vue?vue&type=script&setup=true&lang=js"

import "./AlertaToast.vue?vue&type=style&index=0&id=661e414a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661e414a"]])

export default __exports__